// import Cookies = require("js-cookie");
import { CustomerPortal } from './customer-portal';
declare let Cookiebot: any;

/* apply css3 pie for support: box-shadow, gradients and rounded corners in IE < 10 */
$(function () {
  if ((window as any).PIE) {
    $('#dnn_Slogan').each(function () {
      (window as any).PIE.attach(this);
    });
  }

  // checkCookieConsent();

  detectAnchorAndGoTo();

  /* Fancybox */
  $('.fancybox').fancybox({
    parent: 'form:first',
    padding: 1,
    width: '1140px',
    'max-width': '100%',
  } as any);
  $('[rel^="lightbox"]').fancybox({
    parent: 'form:first',
    padding: 1,
  } as any);
  $('.fancybox-iframe').fancybox({
    parent: 'form:first',
    padding: 1,
  } as any);
  /* Product Tabs (Sliderkit) */
  if ($('.tabs-menu, .product-tab, #application_tab').length > 0) {
    ($('.tabs-menu, .product-tab, #application_tab') as any).sliderkit({
      auto: false,
      tabs: true,
      panelfx: 'none',
      panelfxfirst: 'fading',
      freeheight: true,
    });
  }

  $(document).on('click', 'a:not(.olink)', function (e: any) {
    var _this = $(this);

    if (_this.attr('href') != undefined && _this.attr('href').indexOf('#') != -1) {
      var hash = _this.attr('href').split('#')[1];

      if (hash != '') {
        var elem = $(`[data-anchor="#${hash}"]`);

        if (elem.length > 0) {
          e.preventDefault();

          var offset = elem.offset();
          scrollToAnchor(offset);
        }
      }
    }
  });

  /* Sync Height */
  $(document).ready(function () {
    ($('.co-syncheight') as any).syncHeightResponsive();
  });

  /* Open all PDF links in a new window */
  $("a[href$='.pdf']").attr('target', '_blank');

  $('.ly-nav-mobile-trigger').on('click', function () {
    $('#nav-mobile').slideToggle();
  });

  $('#header-page-title-with-nav .header-page-title').on('click', function () {
    $('#header-page-title-with-nav .header-page-title').toggleClass('active');
    $('#header-page-title-with-nav .ly-nav-sub').slideToggle();
  });

  var navMobileCustomerPortal = $('#nav-mobile .nav-mobile-customer-portal');
  navMobileCustomerPortal.find('.first-line').on('click', function () {
    navMobileCustomerPortal.find('ul').slideToggle();
  });

  $('#header-page-title-with-nav .ly-nav-child-indicator').on('click', function () {
    var elem = $(this);
    var closestLi = elem.closest('li');

    if (closestLi.hasClass('active')) {
      elem.closest('li').removeClass('active');
      elem.closest('li').find('ul').first().slideUp();
    } else {
      elem.closest('ul').find('ul:visible').slideUp();
      elem.closest('ul').find('li.active').removeClass('active');

      elem.closest('li').addClass('active');
      elem.closest('li').find('ul').first().slideDown();
    }
  });

  /* mailencrypting */
  setTimeout(function () {
    $('[data-madr1]').each(function () {
      var $this = $(this);
      var maddr = $this.attr('data-madr1') + '@' + $this.attr('data-madr2') + '.' + $this.attr('data-madr3');
      $this.after('<a href="mailto:' + maddr + '">' + maddr + '</a>');
      $this.hide();
    });
  }, 500);

  /* Newsletter Sign Up in Footer */
  $('#ly-newsletter').click(function (e) {
    e.preventDefault();
    var email = $('#ly-newsletter-email').val() as string;
    var base64Email = utf8_to_b64(email);
    var safeEmail = encodeURIComponent(base64Email);
    window.location.href = '/company/newsletter?email=' + safeEmail;
  });
  $('#ly-newsletter-email').keydown(function (e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      $(this).next('a').trigger('click');
    }
  });

  // Search action -- old??
  //   $('.ly-search a').click(function () {
  //     console.log('ly-search a clicked');
  //     var searchLocation = $(this).attr('data-searchbaseurl');
  //     var inpValue = $(this).prev('input').val().toString();
  //     var url = searchLocation + '#stq=' + encodeURIComponent(inpValue).replace(/\./g, '%2E');
  //     if (inpValue == '') {
  //       return false;
  //     }
  //     //@ts-ignore
  //     const win: Window = window;
  //     //@ts-ignore
  //     win.location = url;
  //     // window.location = searchLocation + (searchLocation.indexOf("?") == -1 ? "?" : "&") + "search=" + encodeURIComponent($(this).prev("input").val()).replace(/\./g, '%2E');
  //   });
  $('.ly-search input').keydown(function (e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      $(this).next('a').trigger('click');
    }
  });

  // ADDSEARCH
  $('.ly-addsearch a').click(function () {
    var searchLocation = $(this).attr('data-searchbaseurl');
    var inpValue = $(this).parent().find('input[type="search"]').val().toString();
    var url = window.location.protocol + '//' + window.location.hostname + searchLocation + '?search=' + encodeURIComponent(inpValue).replace(/\./g, '%2E');

    if (searchLocation.indexOf('archive') > -1) {
      console.log('Archive search detected');
      // https://www.speedgoat.com/help/archive/slrt_25a/9_10_0/page/index
      // Match slrt_ followed by two digits and a single letter (e.g., slrt_25a)
      var versionYearMatch = window.location.href.match(/slrt_\d{2}[a-zA-Z]/i);
      var versionYear = versionYearMatch ? versionYearMatch[0] : '';
      var releaseMatch = window.location.href.match(/\/(\d+_\d+_\d+)\//);
      var release = releaseMatch ? releaseMatch[1] : '';
      // Append versionyear and release to the URL
      url += '&versionyear=' + versionYear + '&release=' + release;
    }
    if (inpValue == '') {
      return false;
    }
    //@ts-ignore
    const win: Window = window;
    //@ts-ignore
    win.location = url;
    // window.location = searchLocation + (searchLocation.indexOf("?") == -1 ? "?" : "&") + "search=" + encodeURIComponent($(this).prev("input").val()).replace(/\./g, '%2E');
  });

  $('.ly-addsearch input').keydown(function (e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      $(this).parents('.ly-addsearch').find('a').trigger('click');
    }
  });

  /* Go to top button */
  $('.ly-top').click(function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return false;
  });

  $('.mobile-search').on('click', function () {
    $(this).find('img').toggle();
    $('.ly-nav-mobile-footer').toggleClass('open-search');
  });

  /* video in Bootstrap Modal function */
  autoPlayYouTubeModal();

  /* responsive tables */
  $('.co-resp-table').wrap("<div class='co-minwidth-outer'></div>").wrap("<div class='co-minwidth-wrapper'></div>").after("<div class='co-minwidth-hint co-minwidth-hint-left'></div><div class='co-minwidth-hint co-minwidth-hint-right'></div>").wrap("<div class='co-minwidth'></div>");
  $('.co-minwidth-wrapper').scroll(function () {
    var self = $(this);
    $('.co-minwidth-hint-left').toggle(self.scrollLeft() > 0);
    $('.co-minwidth-hint-right').toggle(self.scrollLeft() < self[0].scrollWidth - self.outerWidth());
  });

  /* Breadcrumb */
  $('.ly-breadcrumb').toggleClass('ly-breadcrumb-shortened', ($('.ly-breadcrumb .ly-nav > .ly-breadcrumb-item') as any).size() > 2);
  $('.ly-breadcrumb .ly-nav > li:last').addClass('last');
  $('.ly-breadcrumb .ly-nav > li:nth-last-child(2)').addClass('second-last');
  $('.ly-breadcrumb-trigger').click(function () {
    $('.ly-breadcrumb').toggleClass('ly-breadcrumb-shortened');
  });

  new CustomerPortal();

  function utf8_to_b64(str: string) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  adjustFontSize();

  // window.addEventListener('CookiebotOnAccept', function (e) {
  //     checkCookieConsent();
  // })

  // window.addEventListener('CookiebotOnDecline', function (e) {
  //     checkCookieConsent();
  // })
});

// function checkCookieConsent() {
//     if(!Cookiebot.consent.statistics && window.location.href.indexOf("content.speedgoat.com") == -1) {
//         $('.co-youtube-video-wrapper, .vimeo-wrapper').append('<div class="cookieconsent-overlay"><p>Vimeo\'s video player requires cookie consent for proper functioning. Please adjust settings.</p><a class="btn btn-neutral" href="javascript:Cookiebot.renew()">Change your consent</a></div>');
//     } else {
//         $('.cookieconsent-overlay').remove();
//     }
// }

$(window).resize(function () {
  $('.co-minwidth-wrapper').scroll();

  adjustFontSize();
  $('#nav-mobile').hide();
});

function adjustFontSize() {
  var headerTitle = $('.header-title-container').find('.header-page-title');
  var headerTitleFontSize = $('.header-title-container').find('.header-page-title').css('font-size');
  var headerTitleWidth = headerTitle.width();
  var headerColWidth = $('.header-title-container').find('.col-sm-8').width() - 15;

  if (headerTitleWidth > headerColWidth) {
    headerTitle.css({ 'font-size': parseInt(headerTitleFontSize.replace('px', '')) - 2 + 'px' });
    adjustFontSize();
  }
}

$('.co-minwidth-wrapper').scroll();
$(window).scroll(function () {
  if ($(this).scrollTop() > $('.header-background').height()) {
    $('.submenu-container, .sticky-header').addClass('sticky');
  } else {
    $('.submenu-container, .sticky-header').removeClass('sticky');
  }

  if ($(this).scrollTop() > 400) {
    $('.ly-top').addClass('ly-top-visible');
  } else {
    $('.ly-top').removeClass('ly-top-visible');
  }
});

/* video in Bootstrap Modal function */
function autoPlayYouTubeModal() {
  var trigger = $('body').find('[data-toggle-video]');
  trigger.click(function () {
    var theModal = $(this).data('target'),
      videoSRC = $(this).attr('data-toggle-video'),
      videoSRCauto = videoSRC + '?autoplay=1&rel=0';

    $(theModal + ' iframe').attr('src', videoSRCauto);
    $(theModal + ' button.close').click(function () {
      $(theModal + ' iframe').attr('src', videoSRC);
    });
    $('.modal').click(function () {
      $(theModal + ' iframe').attr('src', videoSRC);
    });
  });
}

function detectAnchorAndGoTo() {
  var hash = window.location.hash;

  if (hash != '') {
    console.log('hash', hash);

    var elem = $(`[data-anchor="${hash}"]`);
    if (elem.length > 0) {
      $('body').css('overflow-anchor', 'none');

      var offset = elem.offset();

      if (offset != undefined) {
        scrollToAnchor(offset);
      }
    }
  }
}

function scrollToAnchor(offset: any) {
  var headerHeight = $('.sticky-header').height();

  if (!$('.sticky-header').is(':visible')) {
    headerHeight = $('#header-page-title-with-nav').height();
  }
  // var headerHeight = $('header').height() + $('.sticky-header').height();
  var top = offset.top - headerHeight - 10;

  $('html, body').animate(
    {
      scrollTop: top,
    },
    500
  );
}
